import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PiecesService } from 'app/services/pieces/pieces.service';
import { ProjetsService } from 'app/services/projets/projets.service';
import { AwscontrolService } from 'app/services/aws/awscontrol.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-appartement-list',
  templateUrl: './appartement-list.component.html',
  styleUrls: ['./appartement-list.component.scss']
})
export class AppartementListComponent implements OnInit {
  idAgency: any;
  projet: any;
  list: any[] = [];
  agencyId: string | null = null;

  constructor(
    private agencieService: AgenciesService,
    private piecesService: PiecesService,
    private activatedRoute: ActivatedRoute,
    private projetService: ProjetsService,
    private location: Location,
    private router: Router,
    private awsService: AwscontrolService
  ) { }

  getData(): void {
    this.projetService.getProjet(this.idAgency).subscribe((data: any) => {
      this.projet = data;
      this.list = data.pieces || [];
      if (data.user?.id) {
        this.agencyId = data.user.id.toString();
      } else if (data.userId) {
        this.agencyId = data.userId.toString();
      }
    });
  }
  
  ngOnInit(): void {
    this.idAgency = this.activatedRoute.snapshot.paramMap.get('id');
    this.getData();
  }

  deletePiece(piece: any): void {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteAllImagesAndPiece(piece);
      }
    });
  }

  private deleteAllImagesAndPiece(piece: any): void {
    Swal.fire({
      title: 'Suppression en cours...',
      text: 'Veuillez patienter',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => Swal.showLoading()
    });

    const imagesToDelete = piece.photos || [];
    
    if (imagesToDelete.length === 0) {
      this.deletePieceFromBackend(piece.id);
      return;
    }

    const deletionPromises = imagesToDelete.map((url: string) =>
      this.awsService.deleteFile(url).toPromise()
    );

    // Using 'any' type for results to avoid TypeScript errors
    Promise.allSettled(deletionPromises)
      .then((results: any) => {
        // Ensure results is an array before filtering
        if (Array.isArray(results)) {
          const failed = results.filter((r: any) => r.status === 'rejected');
          if (failed.length > 0) {
            console.warn(`Failed to delete ${failed.length} image(s) from AWS. Continuing with piece deletion.`);
          }
        } else {
          console.warn('Unexpected result from Promise.allSettled, continuing with piece deletion.');
        }
        this.deletePieceFromBackend(piece.id);
      })
      .catch((err) => {
        console.error('Error during image deletion:', err);
        this.deletePieceFromBackend(piece.id);
      });
  }

  private deletePieceFromBackend(pieceId: string): void {
    this.piecesService.deletePiece(pieceId).subscribe({
      next: () => {
        Swal.close();
        Swal.fire("Supprimé !", "L'appartement a été supprimé.", "success");
        this.getData();
      },
      error: (err) => {
        Swal.close();
        console.error('Delete piece error:', err);
        Swal.fire("Erreur !", "Échec de la suppression de l'appartement.", "error");
      }
    });
  }

  navigateBack(): void {
    if (this.agencyId) {
      this.router.navigate(['/list-projet', this.agencyId]);
    } else {
      this.location.back();
    }
  }
}